// Strings for the storeEdit screens brought over from the app (pinto). One namespace
// per file so features can be edited independently; merged in parity/index.ts.
// Mirrors pinto stores_edit.* plus the filters.* store-change strings the editor reuses.
export const storeEditEn = {
  storeEdit: {
    choose: "Choose a store",
    edit: "Edit",
    editA11y: "Edit store #{{id}}",
    search: "Store #, city or ZIP",
    add: "Add a store",
    locked: "Basic lets you change stores once a day. Next change: {{date}}",
    none: "No stores found",
    more: "Want more stores?",
    moreCta: "Pro gets up to 5 home stores per chain",
    dealsNow: "Deals now",
    dealsWithin24h: "Deals within 24h",
    storeChangeLimit: "Store change limit",
    changeFailed: "Couldn’t change store",
    changeFailedBody: "We couldn’t save that store. Please try again.",
    confirmTitle: "Change {{retailer}} store?",
    confirmBody: "This change saves immediately. You won’t be able to change these stores again until {{date}}.",
    confirm: "Change store",
    cancel: "Cancel",
    saving: "Saving…",
  },
} as const;

export const storeEditEs: Record<string, unknown> = {
  storeEdit: {
    choose: "Elige una tienda",
    edit: "Editar",
    editA11y: "Editar la tienda #{{id}}",
    search: "Tienda #, ciudad o código postal",
    add: "Agregar una tienda",
    locked: "Con Basic puedes cambiar tus tiendas una vez al día. Próximo cambio: {{date}}",
    none: "No encontramos tiendas",
    more: "¿Quieres más tiendas?",
    moreCta: "Pro incluye hasta 5 tiendas principales por cadena",
    dealsNow: "Ofertas ahora",
    dealsWithin24h: "Ofertas en 24 h",
    storeChangeLimit: "Límite de cambios de tienda",
    changeFailed: "No se pudo cambiar la tienda",
    changeFailedBody: "No pudimos guardar esa tienda. Inténtalo de nuevo.",
    confirmTitle: "¿Cambiar tienda de {{retailer}}?",
    confirmBody: "Este cambio se guarda de inmediato. No podrás cambiar estas tiendas otra vez hasta {{date}}.",
    confirm: "Cambiar tienda",
    cancel: "Cancelar",
    saving: "Guardando…",
  },
};
